import React from 'react';
import { BasicHeader } from '../../actions/BasicHeader';
import { DocumentCarouselHeaderInfo } from './DocumentCarouselHeaderInfo';
import { makeStyles, Skeleton, SkeletonItem, Spinner } from '@fluentui/react-components';
import { ModalBottomButtonContainer } from '../modals/Styles';
import { PrimaryButton, SecondaryButton } from '../connectedForm/Button';

const useStyles = makeStyles({
  header: {
    width: '300px',
    height: '24px',
  },
  headerSecondarySection: {
    width: '150px',
  },
  item: {
    marginBottom: '10px',
  },
});

const DocumentCarouselSkeleton = () => {
  const styles = useStyles();

  return (
    <>
      <BasicHeader
        secondaryTitle={
          <DocumentCarouselHeaderInfo
            contentLeft={
              <Skeleton>
                <SkeletonItem className={styles.headerSecondarySection} />
              </Skeleton>
            }
            contentRight={
              <Skeleton>
                <SkeletonItem className={styles.headerSecondarySection} />
              </Skeleton>
            }
          />
        }
      >
        <Skeleton aria-label="Loading Content">
          <SkeletonItem size={22} className={styles.header} />
        </Skeleton>
      </BasicHeader>
      <div style={{ padding: '1em' }}>
        <Skeleton aria-label="Loading Content">
          <SkeletonItem className={styles.item} />
          <SkeletonItem className={styles.item} />
        </Skeleton>
      </div>
      <ModalBottomButtonContainer>
        <SecondaryButton disabled={true}>Skip</SecondaryButton>
        <PrimaryButton
          disabled={true}
          iconProps={{
            iconName: 'print',
          }}
        >
          <Spinner size={'tiny'} />
        </PrimaryButton>
      </ModalBottomButtonContainer>
    </>
  );
};

export default DocumentCarouselSkeleton;
